import settingsService from '@/services/settings.service'

export default {
  async loadSettings({ commit, state }) {
    if (state.settingsLoaded) return // prevent duplicate calls

    const res = await settingsService.getSettings()
    commit('SET_SETTINGS', res.data)
    commit('SET_CONTACT', res.data.contact_info || {})
    commit('SET_POLICY_LINKS', res.data.policy_links)
    commit('SET_CHECKOUT', res.data.checkout_settings)
    commit('SET_RESELLER_MARKUP', res.data.reseller_markup || {})
    commit('SET_SETTINGS_LOADED', true)
  },
  async setSettingLoaded({ commit }, payload) {
    commit('SET_SETTINGS_LOADED', payload)
  },
  async getOauthUrl({ commit }, payload) {
    const res = await settingsService.getOauthUrl(payload)
    commit('SET_OAUTH_URL', res)
    return res
  },
  async saveChannel({ commit }, payload) {
    commit('SET_ERROR', null)
    const data = await settingsService.saveChannel(payload)
    commit('SET_MESSAGE', data.message)
    return data
  },

  async getBasicSettings({ commit }) {
    const data = await settingsService.getBasicSettings()
    commit('SET_BASIC_SETTINGS', data)
  },

  async updateBasicSettings({ commit }, data) {
    commit('SET_ERROR', null)
    const res = await settingsService.updateBasicSettings(data)
    //commit('SET_BASIC_SETTINGS', res.data)
    commit('SET_MESSAGE', res.message)
    return data
  },

  async initSettings({ dispatch }) {
    await Promise.all([
      dispatch('fetchContact'),
      dispatch('fetchPolicyLinks'),
      
      dispatch('fetchCheckout'),
      dispatch('fetchResellerMarkup')
    ])
  },
  async fetchContact({ commit }) {
    const data = await settingsService.getContact()
    commit('SET_CONTACT', data.data || {})
  },

  async updateContact({ commit }, payload) {
    commit('SET_ERROR', null)
    commit('SET_CONTACT_LOADING', true)
    const data = await settingsService.updateContact(payload)
    commit('SET_CONTACT', data.data || {})
    commit('SET_CONTACT_LOADING', false)
    commit('SET_MESSAGE', data.message)
  },

  async fetchPolicyLinks({ commit }) {
    const data = await settingsService.getPolicyLinks()
    commit('SET_POLICY_LINKS', data.data)
  },

  async createPolicyLink({ commit }, payload) {
    commit('SET_POLICY_LINK_LOADING', true)
    const data = await settingsService.createPolicyLink(payload)
    commit('ADD_POLICY_LINK', data.data)
    commit('SET_POLICY_LINK_LOADING', false)
    commit('SET_MESSAGE', data.message)
  },

  async updatePolicyLink({ commit }, { id, data }) {
    commit('SET_POLICY_LINK_LOADING', true)
    const res = await settingsService.updatePolicyLink(id, data)
    commit('UPDATE_POLICY_LINK', res.data)
    commit('SET_POLICY_LINK_LOADING', false)
    commit('SET_MESSAGE', res.message)
  },

  async deletePolicyLink({ commit }, id) {
    await settingsService.deletePolicyLink(id)
    commit('DELETE_POLICY_LINK', id)
  },

  async fetchBranding({ commit }) {
    const data = await settingsService.getBranding()
     commit('SET_BRANDING', data.data)
    return data
   
  },

  // ✏️ Update
  async updateBranding({ commit }, formData) {
    commit('SET_ERROR', null)
    commit('SET_BRANDING_LOADING', true)
    try {
      const data = await settingsService.updateBranding(formData)
      commit('SET_BRANDING', data.data)
      commit('SET_BRANDING_LOADING', false)
      commit('SET_MESSAGE', data.message)
    } catch (err) {
      commit('SET_ERROR', err || 'Failed to update profile')
    
      commit('SET_BRANDING_LOADING', false)
      throw err
    }
  },

  async fetchCheckout({ commit }) {
    const data = await settingsService.getCheckout()
    commit('SET_CHECKOUT', data.data)
  },

  async updateCheckout({ commit }, payload) {
    commit('SET_CHECKOUT_LOADING', true)
    const data = await settingsService.updateCheckout(payload)
    commit('SET_CHECKOUT', data.data)
    commit('SET_CHECKOUT_LOADING', false)
    commit('SET_MESSAGE', data.message)
  },

  async fetchResellerMarkup({ commit }) {
    const data = await settingsService.getResellerMarkup()
    commit('SET_RESELLER_MARKUP', data.data)
  },
  async saveResellerMarkup({ commit }, payload) {
    commit('SET_ERROR', null)
    commit('SET_MARKUP_LOADING', true)
    try {
      const data = await settingsService.saveResellerMarkup(payload)
      commit('SET_RESELLER_MARKUP', data.data)
      commit('SET_MARKUP_LOADING', false)
      commit('SET_MESSAGE', data.message)
    } catch (err) {
      commit('SET_ERROR', err || 'Failed to update profile')
    
      commit('SET_MARKUP_LOADING', false)
      throw err
    }
  },

  
  async clearMessage({ commit }) {
    commit('SET_MESSAGE', null)
    commit('SET_ERROR', null)
  },
}